import { connect } from 'react-redux';

import { getIsHotelOnly, searchTypeSelector } from 'src/store/view/selectors';
import { getIsWhitelabel } from 'src/routes/Checkout/store/selectors/view';
import { isFiltersHidden, getIsSubscribeShown } from '../../../selectors/view';
import { isMapViewSelector } from '../../../store/map/selectors';
import {
  hasResults,
  isAwaitingFiltration,
  firstResultsFetchedSelector,
} from '../../../searchStatus/selectors';
import { isEmptySearchSelector } from '../../../store/emptySearch/selectors';
import { isEmptyFiltrationSelector } from '../../../store/emptyFiltration/selectors';
import { getDestinationCountry } from '../../../selectors/searchParams';
import { hotelsCountSelector } from '../../../store/hotels/selectors';
import SearchPageMobile from './SearchPageMobile';

const mapStateToProps = (state) => ({
  isHotelOnly: getIsHotelOnly(state),
  isWhitelabel: getIsWhitelabel(state),
  hideFilters: isFiltersHidden(state),
  isSubscribeShown: getIsSubscribeShown(state),
  isEmptySearch: isEmptySearchSelector(state),
  isEmptyFiltration: isEmptyFiltrationSelector(state),
  mapView: isMapViewSelector(state),
  awaitFiltration: isAwaitingFiltration(state),
  isFirstResultsFetched: firstResultsFetchedSelector(state),
  hasSearchResults: hasResults(state),
  countryName: getDestinationCountry(state).get('name_ru_form3'),
  searchType: searchTypeSelector(state),
  hotelsCount: hotelsCountSelector(state),
});

export default connect(mapStateToProps)(SearchPageMobile);
